/* Ganga Shop V2 Halloween · banda «Faltan para Halloween» (sections/gs-hw-cuenta.liquid), 12/10/2026.
   Actualiza el tiempo que falta cada 1 s, con segundos como la barra del live (Emanuel 12/10: "me gusta más cómo se
   veía la anterior"). Cuenta hasta una fecha real (31/10), no reserva nada. El día de Halloween muestra el texto del
   día y en la fecha de fin oculta la banda. No escucha el scroll ni mide nada de la página. */
(function () {
  if (window.__gsHwCuenta) return;
  window.__gsHwCuenta = true;

  function dos(n) { return n < 10 ? '0' + n : '' + n; }

  function pintar() {
    var bandas = document.querySelectorAll('[data-gs-hw]');
    var ahora = Date.now();
    for (var i = 0; i < bandas.length; i++) {
      var b = bandas[i];
      var fin = Date.parse(b.getAttribute('data-fin'));
      var off = Date.parse(b.getAttribute('data-off'));
      if (!isNaN(off) && ahora >= off) { b.hidden = true; continue; }
      if (isNaN(fin)) continue;
      var t = b.querySelector('[data-gs-hw-t]');
      var falta = fin - ahora;
      if (falta <= 0) {
        var l = b.querySelector('[data-gs-hw-lbl]');
        var hoy = b.getAttribute('data-hoy');
        if (l && hoy && l.textContent !== hoy) {
          var s = document.createElement('strong');
          s.textContent = hoy;
          l.textContent = '';
          l.appendChild(s);
        }
        if (t) t.hidden = true;
        continue;
      }
      if (!t) continue;
      var n = t.querySelectorAll('.gs-hw__n');
      if (n.length < 3) continue;
      n[0].textContent = Math.floor(falta / 864e5);
      n[1].textContent = dos(Math.floor((falta % 864e5) / 36e5));
      n[2].textContent = dos(Math.floor((falta % 36e5) / 6e4));
      if (n[3]) n[3].textContent = dos(Math.floor((falta % 6e4) / 1e3));
    }
  }

  function iniciar() {
    pintar();
    setInterval(pintar, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', pintar);
})();
